import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import {getTableRowClass, getAgencyInfo, formatAsMoney }  from "../../../Bankslip/utils/utils";
import { Link } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import moment from 'moment'
import {matchedFieldTranslation} from '../../utils/utils'

const useStyles = makeStyles((theme) => ({
  tableStyle: {
    border: "none",
    boxShadow: "none",
  },
  blueText: {
    fontFamily: "Open Sans",
    fontWeight: "600",
    color: "#0b1f82"
},
redText: {
    fontFamily: "Open Sans",
    fontWeight: "600",
    color: "#D91A1A"
},
  tableText: {
    fontFamily: "Open Sans",
    fontSize: "12px",
    lineHeight: "16px",
    textAlign: "center",
    margin: "10px",
    padding: "6px",
  },
  tableHeader: {
    textAlign: "center",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    color: '#6F6F6F',
    fontSize: "14px",
    lineHeight: "19px",
    padding: "6px",
  }
}));

const getMatchedFields = (transactions) => {
    let matchedFieldsArray = []
    for(let transaction of transactions){
        matchedFieldsArray.push(Object.keys(transaction['highlight']))
    }
    for(let matchedField of matchedFieldsArray){
        if(matchedField.indexOf('company_key')>-1){
                let ckIndex = matchedField.indexOf('company_key')
                matchedField.splice(ckIndex,1)
        }
    }
    return matchedFieldsArray 
}

const getAgencies=(transaction_account_object)=>{
    let [institution_name] = getAgencyInfo(transaction_account_object)
    if(institution_name){
        return institution_name
    }else{
        return transaction_account_object.participant
    }
}

function BankslipSearchTable(props) {

    const matchedFieldsArray = getMatchedFields(props.historic)
    
    const classes = useStyles();
    useTheme();

    return (
        <Paper className={classes.tableStyle}>
        <Table style={{ padding: "8px"}}>
            <TableHead>
            <TableRow>
                <TableCell className={classes.tableHeader} style={{ width: "5%" }}>ID</TableCell>
                <TableCell className={classes.tableHeader} style={{ width: "7%" }}>Valor</TableCell>
                <TableCell className={classes.tableHeader} style={{ width: "15%" }}>Nome Pagador</TableCell>
                <TableCell className={classes.tableHeader} style={{ width: "10%" }}>Doc Pagador</TableCell>
                <TableCell className={classes.tableHeader} style={{ width: "10%" }}>Instituição Pagador</TableCell>
                <TableCell className={classes.tableHeader} style={{ width: "15%" }}>Nome Recebedor Final</TableCell>
                <TableCell className={classes.tableHeader} style={{ width: "10%" }}>Doc Recebedor Final</TableCell>
                <TableCell className={classes.tableHeader} style={{ width: "10%" }}>Instituição Recebedor Final</TableCell>
                <TableCell className={classes.tableHeader} style={{ width: "8%" }}>Data de Pagamento</TableCell>
                <TableCell className={classes.tableHeader} style={{ width: "10%" }}>Campo encontrado</TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
            {props.historic.map((bankslip,index) => (
                <TableRow
                key={index}
                className={getTableRowClass(index)}
                > 
                <TableCell
                    className={[classes.tableText, classes.blueText, "link", "idOverflow"].join(" ")}
                >
                    <Link
                        className="link"
                        to={"/bankslip/" + bankslip.bankslip_key}
                    >
                        {bankslip.id}
                    </Link>
                </TableCell>
                <TableCell className={classes.tableText}>
                    {formatAsMoney(bankslip.amount, "-")}
                </TableCell>
                <TableCell className={classes.tableText}>
                    <div className={
                        matchedFieldsArray[index].includes("payer.name")
                        ? "blueTextSearchAny"
                        : null}
                    >
                        {bankslip.payer.name}
                    </div>
                </TableCell>
                <TableCell className={classes.tableText}>
                    <div className={
                        matchedFieldsArray[index].includes("payer.document_number")
                        ? "blueTextSearchAny"
                        : null}
                    >
                        {bankslip.payer.document_number}
                    </div>
                </TableCell>
                <TableCell className={[classes.tableText].join(" ")}>
                    <Tooltip title={<p className="tooltipText">{getAgencies(bankslip.payer.account)}</p>}>
                        <div className={
                            matchedFieldsArray[index].includes("payer.account.participant")
                            ? ["textOverflow2","blueTextSearchAny"].join(" ")
                            : "textOverflow2"}
                        >
                            {getAgencies(bankslip.payer.account)}
                        </div>
                    </Tooltip>
                </TableCell>
                <TableCell className={classes.tableText} >
                    <div className={
                        matchedFieldsArray[index].includes("final_recipient.name")
                        ? "blueTextSearchAny"
                        : null}
                    >
                        {bankslip.final_recipient.name}
                    </div>
                </TableCell>
                <TableCell className={classes.tableText} >
                    <div className={
                        matchedFieldsArray[index].includes("final_recipient.document_number")
                        ? "blueTextSearchAny"
                        : null}
                    >
                        {bankslip.final_recipient.document_number}
                    </div>
                </TableCell>
                <TableCell className={[classes.tableText].join(" ")}>
                    <Tooltip title={<p className="tooltipText">{getAgencies(bankslip.final_recipient.account)}</p>}>
                        <div className={
                            matchedFieldsArray[index].includes("final_recipient.account.participant")
                            ? ["textOverflow2","centerText","labelSpace", "blueTextSearchAny"].join(" ")
                            : ["textOverflow2","centerText","labelSpace"].join(" ")}
                        >
                            {getAgencies(bankslip.final_recipient.account)}
                        </div>
                    </Tooltip>
                </TableCell>
                <TableCell className={classes.tableText}>
                    {moment(bankslip.bankslip_payment_date).format("DD/MM/YYYY HH:mm")}
                </TableCell>
                <TableCell className={classes.tableText}>
                    {matchedFieldsArray[index].map(matchedField => matchedFieldTranslation(matchedField)).join(", ")}
                </TableCell>
                </TableRow>
            ))}
            </TableBody>
        </Table>
        </Paper>
    );
}

export default BankslipSearchTable;
